module.exports = "/assets/data/4cb2793b2d46b30ace8a86d1e6f30892-NP20.data.json";